import { NetworkActionPrefix, ActionType, RequestStatus, SWOTArea } from '../utils/constants';
import defaults from '../api/defaults';
import { deepAssign } from '../utils';
import {
    pipeReducers, combineReducers, synchronizableEnumReducer,
    networkActionReducer, networkObjectLoadReducer,
    networkEntityLoadReducer, optimisticNetworkEntityLoadReducer, networkEntityAddReducer, networkEntityEditReducer, networkEntityDeleteReducer,
    networkPaginationLoadReducer, paginationSlicePushReducer, networkObjectVoidReducer
} from '../utils/reducerFactory';

function index(state, action, id) {
    return id !== undefined ? (id = state.getIndexByID(id)) !== -1 ? id : state.length : undefined;
}

const keyVariables = {
    sessionIndex: (state, action) => index(state, action, action.sessionID),
    participantIndex: (state, action) => index(state, action, action.participantID),
    topicIndex: (state, action) => index(state, action, action.topicID),
    indicatorIndex: (state, action) => index(state, action, action.indicatorID),
    batchIndex: (state, action) => index(state, action, action.batchID),
    voteIndex: (state, action) => index(state, action, action.voteID),
    commentIndex: (state, action) => index(state, action, action.commentID),
    swotInbox: (state, action) => index(state, action, action.sWOTInboxID)
};


const
    voidAllSWOTSessionsReducer = networkObjectVoidReducer(ActionType.VOID_ALL_SWOT_SESSIONS),
    voidAllSWOTTopicsReducer = networkObjectVoidReducer(ActionType.VOID_ALL_SWOT_TOPICS);

let topics;

const swot = pipeReducers(
    combineReducers({
        areas: synchronizableEnumReducer(NetworkActionPrefix.LOAD_ALL_SWOT_AREAS_PREFIX, defaults.NetworkArray, SWOTArea, 'SWOTArea'),
        sessions: pipeReducers(
            networkObjectLoadReducer(NetworkActionPrefix.LOAD_ALL_SWOT_SESSIONS_PREFIX, defaults.NetworkArray),
            combineReducers({
                Data: combineReducers({
                    '@sessionIndex': pipeReducers(
                        optimisticNetworkEntityLoadReducer(NetworkActionPrefix.LOAD_SWOT_SESSION_PREFIX, defaults.SWOTSessionReport, (state, action) => action.sessionID),
                        networkEntityAddReducer(NetworkActionPrefix.ADD_SWOT_SESSION_PREFIX, null, (state, action) => action.session),
                        networkEntityEditReducer(NetworkActionPrefix.EDIT_SWOT_SESSION_PREFIX, null, (state, action) => action.session),
                        (state, action) => {
                            switch (action.type) {
                                case ActionType.START_SWOT_VOTE_BATCH:
                                    return deepAssign(networkActionReducer(NetworkActionPrefix.CLOSE_SWOT_VOTE_BATCH_PREFIX)(state, action), {
                                        ActiveBatchDateStarted: new Date(),
                                        ActiveBatchDateClosed: null
                                    });

                                case ActionType.START_SWOT_VOTE_BATCH_PENDING:
                                case ActionType.START_SWOT_VOTE_BATCH_SUCCESS:
                                case ActionType.START_SWOT_VOTE_BATCH_FAIL:
                                    return networkActionReducer(NetworkActionPrefix.START_SWOT_VOTE_BATCH_PREFIX)(state, action);

                                case ActionType.CLOSE_SWOT_VOTE_BATCH:
                                case ActionType.CLOSE_SWOT_VOTE_BATCH_PENDING:
                                case ActionType.CLOSE_SWOT_VOTE_BATCH_FAIL:
                                    return networkActionReducer(NetworkActionPrefix.CLOSE_SWOT_VOTE_BATCH_PREFIX)(state, action);

                                case ActionType.CLOSE_SWOT_VOTE_BATCH_SUCCESS:
                                    state = deepAssign(networkActionReducer(NetworkActionPrefix.CLOSE_SWOT_VOTE_BATCH_PREFIX)(state, action), {
                                        ActiveBatchDateClosed: new Date(),
                                        Topics:
                                            state.Topics.some(({ VoteBatches: { Data } }) => Data.last().Votes.some(({ TimeStamp }) => TimeStamp)) ?
                                                state.Topics.map(topic => deepAssign(topic, {
                                                    VoteBatches: {
                                                        Data: topic.VoteBatches.Data.map(batch => ({ DateClosed: batch.DateClosed || new Date() }))
                                                    }
                                                })) :
                                                state.Topics.map(topic => deepAssign(topic, {
                                                    VoteBatches: {
                                                        Data: topic.VoteBatches.Data.slice(0, -1)
                                                    }
                                                }))

                                    });

                                    return deepAssign(state, {
                                        Topics: state.Topics.map(state => ({
                                            Importance: state.VoteBatches.Data.length && state.VoteBatches.Data.last().Votes.some(vote => vote.TimeStamp) ?
                                                state.VoteBatches.Data.last().Votes
                                                    .filter(vote => vote.TimeStamp)
                                                    .meanBy(vote => vote.Importance || 0) || 0 :
                                                null
                                        }))
                                    });

                                default:
                                    return state;
                            }
                        },
                        networkEntityDeleteReducer(NetworkActionPrefix.DELETE_SWOT_SESSION_PREFIX),
                        combineReducers({
                            Participants: combineReducers({
                                '@participantIndex': pipeReducers(
                                    networkEntityAddReducer(NetworkActionPrefix.ADD_SWOT_PARTICIPANT_PREFIX, null, (state, action) => action.participant),
                                    networkEntityDeleteReducer(NetworkActionPrefix.DELETE_SWOT_PARTICIPANT_PREFIX, null)
                                )
                            }, keyVariables),
                            Topics: topics = pipeReducers(
                                (state, action) => {
                                    switch (action.type) {
                                        case ActionType.ADD_ALL_SWOT_TOPICS:
                                        case ActionType.ADD_ALL_SWOT_TOPICS_PENDING:
                                        case ActionType.ADD_ALL_SWOT_TOPICS_SUCCESS:
                                        case ActionType.ADD_ALL_SWOT_TOPICS_FAIL:
                                            return action.topics.reduce((state, topic, index) => topics(state, {
                                                ...action,
                                                type: action.type.replace(/TOPICS/g, 'TOPIC').replace(/ALL_/, ''), // TODO handle Symbolish case (but who am I kidding?..)
                                                topicID: topic.ID,
                                                topic: topic,
                                                response: action.response && action.response[index]
                                            }), state);

                                        case ActionType.EDIT_ALL_SWOT_TOPICS:
                                        case ActionType.EDIT_ALL_SWOT_TOPICS_PENDING:
                                        case ActionType.EDIT_ALL_SWOT_TOPICS_SUCCESS:
                                        case ActionType.EDIT_ALL_SWOT_TOPICS_FAIL:
                                            return action.topics.reduce((state, topic, index) => topics(state, {
                                                ...action,
                                                type: action.type.replace(/TOPICS/g, 'TOPIC').replace(/ALL_/, ''), // TODO handle Symbolish case (but who am I kidding?..)
                                                topicID: topic.ID,
                                                topic: topic
                                            }), state);

                                        case ActionType.EDIT_SWOT_VOTES:
                                        case ActionType.EDIT_SWOT_VOTES_PENDING:
                                        case ActionType.EDIT_SWOT_VOTES_SUCCESS:
                                        case ActionType.EDIT_SWOT_VOTES_FAIL:
                                            return state.reduce((state, topic) =>
                                                topic.VoteBatches.Data.reduce((state, batch) =>
                                                    batch.Votes.reduce((state, vote) =>
                                                        action.votes.getByID(vote.ID) ?
                                                            topics(state, {
                                                                ...action,
                                                                type: action.type.replace(/VOTES/g, 'VOTE'), // TODO handle Symbolish case (but who am I kidding?..)
                                                                topicID: topic.ID,
                                                                batchID: batch.ID,
                                                                voteID: vote.ID,
                                                                vote: action.votes.getByID(vote.ID),
                                                                response: action.response && action.response[action.votes.getIndexByID(vote.ID)]
                                                            }) :
                                                            state,
                                                        state),
                                                    state),
                                                state);

                                        default:
                                            return state;
                                    }
                                },
                                combineReducers({
                                    '@topicIndex': pipeReducers(
                                        networkEntityLoadReducer(NetworkActionPrefix.LOAD_SWOT_TOPIC_PREFIX),
                                        networkEntityAddReducer(NetworkActionPrefix.ADD_SWOT_TOPIC_PREFIX, null, (state, action) => action.topic),
                                        networkEntityEditReducer(NetworkActionPrefix.EDIT_SWOT_TOPIC_PREFIX, null, (state, action) => action.topic),
                                        networkEntityDeleteReducer(NetworkActionPrefix.DELETE_SWOT_TOPIC_PREFIX),
                                        combineReducers({
                                            VoteBatches: pipeReducers(
                                                networkPaginationLoadReducer(NetworkActionPrefix.LOAD_SWOT_VOTE_BATCHES_SLICE_PREFIX, defaults.SWOTTopicVoteBatchReportPaginationSlice),
                                                combineReducers({
                                                    Data: combineReducers({
                                                        '@batchIndex': combineReducers({
                                                            Votes: combineReducers({
                                                                '@voteIndex': networkEntityEditReducer(NetworkActionPrefix.EDIT_SWOT_VOTE_PREFIX, null, (state, action) => action.vote)
                                                            }, keyVariables)
                                                        }, keyVariables)
                                                    }, keyVariables)
                                                }, keyVariables),
                                                networkObjectVoidReducer(ActionType.VOID_ALL_SWOT_VOTE_BATCHES, defaults.SWOTTopicVoteBatchReportPaginationSlice)
                                            ),
                                            Comments: pipeReducers(
                                                networkPaginationLoadReducer(NetworkActionPrefix.LOAD_SWOT_COMMENTS_SLICE_PREFIX, defaults.SWOTTopicCommentPaginationSlice),
                                                paginationSlicePushReducer(ActionType.ADD_SWOT_COMMENT, defaults.SWOTTopicCommentPaginationSlice),
                                                combineReducers({
                                                    Data: combineReducers({
                                                        '@commentIndex': pipeReducers(
                                                            networkEntityLoadReducer(NetworkActionPrefix.LOAD_SWOT_COMMENT_PREFIX),
                                                            networkEntityAddReducer(NetworkActionPrefix.ADD_SWOT_COMMENT_PREFIX, null, (state, action) => action.comment)
                                                        )
                                                    }, keyVariables)
                                                }, keyVariables),
                                                networkObjectVoidReducer(ActionType.VOID_ALL_SWOT_COMMENTS, defaults.SWOTTopicCommentPaginationSlice)
                                            )
                                        }),
                                        (state, action) => {
                                            switch (action.type) {
                                                case ActionType.LOAD_SWOT_VOTE_BATCHES_SLICE_SUCCESS:
                                                    return deepAssign(state, {
                                                        Importance: state.VoteBatches.Data.last().Votes.some(vote => vote.TimeStamp) ?
                                                            state.VoteBatches.Data.last().Votes
                                                                .filter(vote => vote.TimeStamp)
                                                                .meanBy(vote => vote.Importance || 0) || 0 :
                                                            null
                                                    });

                                                case ActionType.EDIT_SWOT_VOTE:
                                                    if (DEBUG && state.VoteBatches.Data.getByID(action.batchID)) {
                                                        console.error(`Can't calculate average importance of SWOTTopic ${state.ID}. In order to edit votes of a topic, corresponding batch have to be preloaded.`);
                                                    }

                                                    return deepAssign(state, {
                                                        Importance: state.VoteBatches.Data.last().Votes.some(vote => vote.TimeStamp) ?
                                                            state.VoteBatches.Data.last().Votes
                                                                .filter(vote => vote.TimeStamp)
                                                                .meanBy(vote => vote.Importance || 0) || 0 :
                                                            null
                                                    });

                                                default:
                                                    return state;
                                            }
                                        }
                                    )
                                }, keyVariables),
                                (state, action) => state && action.type === ActionType.VOID_ALL_SWOT_TOPICS ?
                                    voidAllSWOTTopicsReducer(deepAssign(state, state.map(session => voidAllSWOTTopicsReducer(session, action))), action) :
                                    state
                            )
                        }, keyVariables),
                        function (state, action) {
                            switch (action.type) {
                                case ActionType.LOAD_ALL_SWOT_TOPICS:
                                case ActionType.LOAD_ALL_SWOT_TOPICS_PENDING:
                                case ActionType.LOAD_ALL_SWOT_TOPICS_SUCCESS:
                                case ActionType.LOAD_ALL_SWOT_TOPICS_FAIL:
                                    const newState = pipeReducers(
                                        networkObjectLoadReducer(NetworkActionPrefix.LOAD_ALL_SWOT_TOPICS_PREFIX),
                                        networkObjectVoidReducer(ActionType.VOID_ALL_SWOT_TOPICS)
                                    )({ Data: state.Topics, Custom: state.Custom }, action);
                                    return deepAssign(state, {
                                        ...state,
                                        Topics: newState.Data,
                                        Custom: newState.Custom
                                    });

                                default:
                                    return state;
                            }
                        }
                    )
                }, keyVariables)
            }, keyVariables),
            (state, action) => state && action.type === ActionType.VOID_ALL_SWOT_SESSIONS ?
                voidAllSWOTSessionsReducer(deepAssign(state, { Data: state.Data.map(session => voidAllSWOTSessionsReducer(session, action)) }), action) :
                state
        ),
        swotInboxes: pipeReducers(
            networkObjectLoadReducer(NetworkActionPrefix.LOAD_ALL_SWOT_INBOXS_PREFIX, defaults.NetworkArray),
            combineReducers({
                Data: combineReducers({
                    '@swotInbox': pipeReducers(
                        networkEntityAddReducer(NetworkActionPrefix.ADD_SWOT_INBOX_PREFIX, null, (state, action) => action.sWOTInbox),
                        networkEntityDeleteReducer(NetworkActionPrefix.DELETE_SWOT_INBOX_PREFIX),
                        networkEntityEditReducer(NetworkActionPrefix.EDIT_SWOT_INBOX_PREFIX, defaults.SWOTInbox, (state, action) => action.sWOTInbox),
                        networkEntityLoadReducer(NetworkActionPrefix.LOAD_SWOT_INBOX_PREFIX, null, (state, action) => action.sWOTInboxID),
                        (state, action) => {
                            if (action.type === ActionType.ADD_SWOT_INBOX_PENDING) {
                                return deepAssign(state, { BlobStorageURI: "" });
                            }

                            return state;
                        }
                    )
                }, keyVariables)
            })
        )
    }, keyVariables),
    (state, action) => {
        switch (action.type) {
            case ActionType.VOID_CORPORATE_STRUCTURE:
            case ActionType.DELETE_PRODUCT_SUCCESS:
            case ActionType.DELETE_GEO_AREA_SUCCESS:
            case ActionType.DELETE_CUSTOMER_SUCCESS:
            case ActionType.DELETE_TRACKING_LEVEL_1_ITEM_SUCCESS:
            case ActionType.DELETE_TRACKING_LEVEL_2_ITEM_SUCCESS:
            case ActionType.DELETE_TRACKING_LEVEL_3_ITEM_SUCCESS:
            case ActionType.DELETE_TRACKING_LEVEL_4_ITEM_SUCCESS:
            case ActionType.DELETE_TREND_TOPIC_SUCCESS:
                // TODO make it more targeted, not all parts require update
                return swot(undefined, { type: '@@redux/INIT' });
            default:
                return state;
        }
    }
);

export default swot;